import type { AIRateLimit, AIRateLimitErrorBody } from './types';

/**
 * Parse a 429 response into an `AIRateLimit`, or null if it isn't a rate-limit
 * rejection. Shared by every chat transport (venue assistant, Motif) that talks
 * to a route returning the `rate_limit_exceeded` envelope. Clones the response
 * so the body stays readable by the caller.
 */
export const parseRateLimitFromResponse = async (
  response: Response,
): Promise<AIRateLimit | null> => {
  if (response.status !== 429) return null;
  try {
    const body = (await response.clone().json()) as AIRateLimitErrorBody;
    if (body.error !== 'rate_limit_exceeded') return null;
    return {
      window: body.window,
      limit: body.limit,
      remaining: body.remaining,
      resetAt: new Date(body.resetAt),
    };
  } catch {
    return null;
  }
};
